import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.slice.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  class: "activity-list"
};
var _hoisted_2 = {
  key: 0,
  class: "list-loading"
};
var _hoisted_3 = {
  key: 1
};
var _hoisted_4 = ["onClick"];
var _hoisted_5 = {
  class: "top"
};
var _hoisted_6 = {
  class: "bottom"
};
var _hoisted_7 = {
  key: 2,
  class: "list-empty"
};
import { ref, onMounted } from 'vue';
import { studentActivityList } from '@/api/home';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var loading = ref(false);
    var activityList = ref([]);
    var _ref = getStore({
        name: 'accessInfo'
      }) || {},
      user_id = _ref.user_id;
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _data$data, _yield$studentActivit, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            loading.value = true;
            _context.n = 1;
            return studentActivityList(user_id, {
              current: 1,
              size: 999,
              status: 0
            });
          case 1:
            _yield$studentActivit = _context.v;
            data = _yield$studentActivit.data;
            activityList.value = (data === null || data === void 0 || (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.records) || [];
            console.log(data);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.log(_t);
          case 3:
            _context.p = 3;
            loading.value = false;
            return _context.f(3);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2, 3, 4]]);
    })));
    var handleClickActivity = function handleClickActivity(item) {
      var path = "activity?activity=/sub-activity-svc/activityDetail?activityId=".concat(item.activityId);
      window.open("".concat(window.location.origin, "/").concat(path));
    };
    return function (_ctx, _cache) {
      var _activityList$value, _activityList$value2;
      var _component_Loading = _resolveComponent("Loading");
      var _component_t_image = _resolveComponent("t-image");
      var _component_Empty = _resolveComponent("Empty");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[0] || (_cache[0] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), !loading.value && (_activityList$value = activityList.value) !== null && _activityList$value !== void 0 && _activityList$value.length ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activityList.value, function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.activityId,
          class: "activity-item",
          onClick: function onClick($event) {
            return handleClickActivity(item);
          }
        }, [_createElementVNode("div", _hoisted_5, [_createVNode(_component_t_image, {
          shape: "square",
          fit: "fill",
          src: item.cover
        }, null, 8, ["src"]), _createElementVNode("span", {
          class: "status",
          style: _normalizeStyle({
            background: item.status === 1 ? '#FFA63A' : item.status === 2 ? '#0CB078' : '#DCDDE1'
          })
        }, _toDisplayString(item.status === 1 ? '未开始' : item.status === 2 ? '进行中' : '已结束'), 5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", null, _toDisplayString(item.activityName), 1), _createElementVNode("span", null, _toDisplayString(item === null || item === void 0 ? void 0 : item.activityStartTime.slice(5)) + " - " + _toDisplayString(item === null || item === void 0 ? void 0 : item.activityEndTime.slice(5)), 1)])], 8, _hoisted_4);
      }), 128))])) : _createCommentVNode("", true), !loading.value && !((_activityList$value2 = activityList.value) !== null && _activityList$value2 !== void 0 && _activityList$value2.length) ? (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_Empty)])) : _createCommentVNode("", true)]);
    };
  }
};